
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSignArrowUpRight as ObiSignArrowUpRightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sign-arrow-up-right.js';
 
 
 

 
 export const ObiSignArrowUpRight = createComponent({
   react: React,
   tagName: 'obi-sign-arrow-up-right',
   elementClass: ObiSignArrowUpRightElement,
   events: {
     
   }
  });
 
 